import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import DownloadIcon from '@mui/icons-material/Download';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { jsPDF } from 'jspdf';

// Import invitation PDF images
import invitationImage1 from '../../../../assets/images/BFPPdf/Your Invitation to the Billionaires for Peace Conclave as a VIP I Am Peacekeeper Partner_1.jpg';
import invitationImage2 from '../../../../assets/images/BFPPdf/Your Invitation to the Billionaires for Peace Conclave as a VIP I Am Peacekeeper Partner_2.jpg';
import invitationImage3 from '../../../../assets/images/BFPPdf/Your Invitation to the Billionaires for Peace Conclave as a VIP I Am Peacekeeper Partner_3.jpg';
import invitationImage4 from '../../../../assets/images/BFPPdf/Your Invitation to the Billionaires for Peace Conclave as a VIP I Am Peacekeeper Partner_4.jpg';

// Share message for Web Share API (preview and share)
const BPF_SHARE_MESSAGE = `Your Invitation to the Billionaires for Peace Conclave 🌍
Together as VIP I Am Peacekeeper Partner 🔗


Dear Prospective VIP I Am Peacekeeper Partner ✉️,

With warm greetings, I invite you to the Billionaires for Peace Conclave 🌍 on Thursday, 2nd April 2026 📅 at Grand Hyatt, Dubai 📍 as a VIP I Am Peacekeeper Partner 🎗️.

This focused gathering brings leaders, Nobel Peace Laureates and change-makers together to advance Inner Peace and World Peace through a clear method: one Conclave a year supported by research 🔬, advocacy 📣 and action ⚙️. We at the I Am Peacekeeper Movement confirm the attendance of 4 Nobel Peace Laureates 📈 for the Conclave. An intimate circle of 210 Billionaires 💰 is envisaged, with Legacy Circle status 💠 reserved for the first 210 confirmed I Am Peacekeeper Billionaire Patrons.

On Thursday, 2nd April 2026, the Conclave aims to unfold in one continuous ribbon of purpose: 🤝 10:30 AM – 12:45 PM ~ I Am Peacekeeper Power Networking to start the day through group interactions and curated one-on-one meetings, which flows into 🍽️ 1:00 PM – 2:00 PM ~ I Am Peacekeeper Leadership Luncheon where rapport is deepened and resolve clarified, then into 🚀 2:10 PM ~ the official launch of the Billionaires for Peace Conclave, followed by 🎤 2:15 PM ~ the Founder's Address by myself, Dr. Huzaifa Khorakiwala, and then 🕊️ 2:21 PM – 3:21 PM ~ I Am Peacekeeper Nobel Peace Laureates' Plenary with addresses by Honourable Kailash Satyarthi, Honourable Leymah Roberta Gbowee, Honourable Prof. Mohan Munasinghe and Honourable Prof. Ouided Bouchamaoui, moving into 🧘 3:30 PM – 4:30 PM ~ Inner Peace as the Foundation of World Peace with 12 Distinguished Billionaires, then ⚖️ 5:00 PM – 6:00 PM ~ Justice is the Companion of Peace with 12 Eminent Billionaires, leading into 🏙️ 6:00 PM – 7:00 PM ~ I Am Peacekeeper – Calm Before the Champion & Crown as a reflection break with private interactions and media moments, preparing the room for 👑 7:00 PM – 8:00 PM ~ I Am Peacekeeper Champion & Crown Ceremony with the presentation of awards and concluding in fellowship at 🎉 8:30 PM onwards ~ I Am Peacekeeper Gala Banquet, our curated sit-down dinner where each table is hosted by one Billionaire or one Nobel Peace Laureate to enable meaningful dialogue and shared purpose.

Nobel Presence ✨
Your participation places you among peers committed to measurable impact, with dialogue shaped by Nobel Peace Laureates and a high-calibre audience of Global Patrons.


👑 I Am Peacekeeper Crown ~ Billionaires for Peace


1. 🏗️ Mr. Aliko Mohammad Dangote ~ Industrialist & philanthropist; Founder & President/Chief Executive, Dangote Industries Limited, Nigeria.
2. ⚽ Mr. Cristiano Ronaldo dos Santos Aveiro ~ Professional footballer; Forward & captain, Al-Nassr FC & Portugal national team, Portugal.
3. ✝️ His Holiness Pope Leo XIV ~ Supreme Pontiff; Bishop of Rome & Head, Holy See, USA.
4. 🎁 Ms. MacKenzie Scott ~ Philanthropist & author; Founder, Yield Giving, USA.
5. 🕌 H.H. Sheikh Mohamed bin Zayed bin Sultan Al Nahyan ~ Head of state; President, UAE.
6. 🇮🇳 H.E. Narendra Damodardas Modi ~ Head of government; Prime Minister, Government of India, India.
7. ☸️ Gurudev Sri Sri Ravi Shankar ~ Spiritual teacher & humanitarian; Founder, Art of Living Foundation, India.
8. 🎙️ Ms. Selena Marie Gomez ~ Singer, actress & producer; Founder, Rare Beauty, USA.
9. 🧵 Mr. Tadashi Yanai ~ Business leader & retailer; Chairman, President & CEO, Fast Retailing Co., Ltd. & UNIQLO, Japan.
10. 🎤 Ms. Taylor Alison Swift ~ Singer-songwriter & producer; Founder, Taylor Swift Productions, Inc., USA.
11. 🏏 Mr. Virat Kohli ~ International cricketer; Batsman, Royal Challengers Bengaluru (RCB), India.
12. 🎓 Mr. William Henry Gates III ~ Technologist & philanthropist; Chair, Gates Foundation, USA.

(Awardees listed alphabetically according to first name.)


The I Am Peacekeeper Crown 🏆
Under the protocol of the Governing Council chaired by myself, Dr. Huzaifa Khorakiwala, the I Am Peacekeeper Crown will be facilitated by 4 Nobel Peace Laureates at Grand Hyatt, Dubai in a path-breaking ceremony. Upon each Awardee's confirmation, the I Am Peacekeeper Crown will be conferred on stage before an assembly of leaders and I Am Peacekeeper; a clear pledge to advance Justice, Love & Peace. Together these 12 embody builders of industry at global scale, heads of state and public servants, spiritual guides, humanitarians, champions of sport, cultural storytellers and philanthropists whose work spans enterprise, governance, technology, faith, sport and the arts, touching continents and billions of lives for the common good.


Your Role and Commitment 🎖️
As a VIP I Am Peacekeeper Partner, your contribution is $12,000 for Thursday, 2nd April 2026.
🪑 For the sit-down dinner, each table will be curated to include one Billionaire or one Nobel Peace Laureate, a defining value of the VIP I Am Peacekeeper Partner engagement.

12 Programmes 🧩
The I Am Peacekeeper Movement is non-religious and non-political, delivering measurable impact through 12 Peace Programmes that nurture both Inner Peace and World Peace. From Schools – Colleges & Universities to Organisations & Corporates, from Cities and Events to Networks, Gifts and the Institute, through Influencers, the Welfare Fund, the Cafee, Voices and Arts & Publications, each programme channels values into visible action, translating peaceful intent into purposeful impact.

Themes 🧭
Our 4 guiding themes are Network, Natural, Noble and Nurturing; a succinct framework to keep purpose, people and planet aligned.

Track Record 🏛️
On 12th – 13th April 2025, the Global Justice, Love & Peace Summit at Expo City, Dubai hosted 10 Nobel Peace Laureates on a single stage. On 4th September 2025, the I Am Peacekeeper Movement was formally launched at the Opera Ballroom, Taj Business Bay, Dubai, unveiling the 12 I Am Peacekeeper Programmes that underpin this work 🖼️.

RSVP and Next Steps ✅
I would be honoured to welcome you as a VIP I Am Peacekeeper Partner at the Billionaires for Peace Conclave on Thursday, 2nd April 2026 in Dubai. Kindly confirm your attendance at your convenience so we may share your VIP I Am Peacekeeper Partner brief and extend the formalities. If you wish to confirm your commitment now, please use our secure payment page 💳: https://buy.stripe.com/bJe9AS7gPf7U1Rdd1Lc7u0d . The contribution amount is automatically set at $12,000 and will be converted into your local currency at checkout. An acknowledgement will follow from the I Am Peacekeeper Movement.

May our intent become steady strength and may it ripple into Justice, Love & Peace across every community 🫶.

Yours in Peace ☮,

Dr. Huzaifa Khorakiwala
* Executive Director, Wockhardt
* Owner, Jupiter Events LLC
* Founder, I Am Peacekeeper Movement
* CEO, Wockhardt Foundation
* Chairman, Global Justice, Love & Peace Summit
* Chairman, Billionaires for Peace

On behalf of Dr. Huzaifa Khorakiwala

I Am Peacekeeper [Full Name]
🆔: [ID Number]`;

// Returns share message with user name and peacekeeper ID in place of placeholders
const getBPFShareMessage = (user) => {
  const name = user?.username || user?.name || 'Full Name';
  const id = user?.peacekeeper_id || 'ID Number';
  return BPF_SHARE_MESSAGE.replace('I Am Peacekeeper [Full Name]', `I Am Peacekeeper ${name}`).replace('🆔: [ID Number]', `🆔: ${id}`);
};

const BPF = () => {
  const { user } = useSelector((state) => state.auth);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [currentPage, setCurrentPage] = useState(0);
  const [downloadStatus, setDownloadStatus] = useState('');
  const [isSharing, setIsSharing] = useState(false);
  const [showMessagePreview, setShowMessagePreview] = useState(false);
  
  // Invitation PDF images from assets folder
  const invitationImages = [invitationImage1, invitationImage2, invitationImage3, invitationImage4];
  const totalPages = invitationImages.length;

  const nextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Render current page image
  const renderPage = () => {
    const currentImage = invitationImages[currentPage];
    
    return (
      <Box 
        sx={{ 
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center'
        }}
      >
        <img 
          src={currentImage} 
          alt={`Invitation Page ${currentPage + 1}`}
          style={{
            maxWidth: '100%',
            height: 'auto',
            maxHeight: '80vh',
            objectFit: 'contain'
          }}
        />
      </Box>
    );
  };

  // Helper function to detect iOS devices
  const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) || 
           (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  };

  // Helper function to detect Safari browser
  const isSafari = () => {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  };

  // iOS-specific PDF download handler - Force save to device
  const handleIOSPDFDownload = (blob, filename) => {
    try {
      console.log('Handling iOS PDF download for BPF:', filename);
      setDownloadStatus('Preparing PDF download for iOS...');

      // For iOS PDFs, we need to force save to device, not open in browser
      // Try multiple approaches in sequence
      
      // Approach 1: Try Web Share API first (most reliable for iOS)
      if (navigator.share && navigator.canShare) {
        try {
          const file = new File([blob], filename, { type: 'application/pdf' });
          if (navigator.canShare({ files: [file] })) {
            navigator.share({
              files: [file],
              title: 'BPF Invitation PDF',
              text: 'Choose "Save to Files" to save to your device.'
            }).then(() => {
              setDownloadStatus('PDF shared successfully! Choose "Save to Files" to save to your device.');
              setTimeout(() => setDownloadStatus(''), 5000);
            }).catch((shareError) => {
              if (shareError.name !== 'AbortError') {
                console.log('Web Share failed, trying alternative method:', shareError);
                handleIOSPDFFallback(blob, filename);
              } else {
                setDownloadStatus('');
              }
            });
            return;
          } else {
            console.log('Web Share API cannot share files, trying fallback');
            handleIOSPDFFallback(blob, filename);
            return;
          }
        } catch (shareError) {
          console.log('Web Share API error, trying fallback:', shareError);
          handleIOSPDFFallback(blob, filename);
          return;
        }
      }

      // If Web Share is not available, use fallback
      console.log('Web Share API not available, using fallback');
      handleIOSPDFFallback(blob, filename);

    } catch (error) {
      console.error('iOS PDF download failed:', error);
      handleIOSPDFFallback(blob, filename);
    }
  };

  // iOS PDF fallback method - More aggressive approach
  const handleIOSPDFFallback = (blob, filename) => {
    try {
      console.log('Using iOS PDF fallback method for BPF:', filename);
      setDownloadStatus('Preparing PDF for device save...');

      // Create a new blob with explicit PDF MIME type
      const pdfBlob = new Blob([blob], { type: 'application/pdf' });
      
      // Try to use Cordova file system if available
      if (window.cordova && window.cordova.file) {
        console.log('Using Cordova file system for PDF save...');
        setDownloadStatus('Saving PDF to device using Cordova...');
        
        saveFileToDevice(pdfBlob, filename).then((filePath) => {
          console.log('PDF saved successfully to:', filePath);
          setDownloadStatus(`PDF saved to device: ${filename}`);
          
          // Show toast notification if available
          if (window.cordova && window.cordova.plugins && window.cordova.plugins.toast) {
            window.cordova.plugins.toast.show(`PDF saved: ${filename}`, 'long', 'bottom');
          }
        }).catch((error) => {
          console.error('Cordova save failed, trying web fallback:', error);
          handleIOSPDFWebFallback(pdfBlob, filename);
        });
        return;
      }

      // Web fallback for non-Cordova environments
      handleIOSPDFWebFallback(pdfBlob, filename);

    } catch (error) {
      console.error('iOS PDF fallback failed:', error);
      setDownloadStatus('PDF save failed. Please try the Web Share option.');
    }
  };

  // iOS PDF web fallback - Force download without opening
  const handleIOSPDFWebFallback = (pdfBlob, filename) => {
    try {
      console.log('Using iOS PDF web fallback for BPF:', filename);
      setDownloadStatus('Preparing PDF download...');

      // Create a data URL instead of blob URL to force download
      const reader = new FileReader();
      reader.onload = () => {
        const dataUrl = reader.result;
        
        // Create a temporary link element with aggressive download settings
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = filename;
        link.style.display = 'none';
        
        // Add attributes to force download
        link.setAttribute('download', filename);
        link.setAttribute('type', 'application/pdf');
        link.setAttribute('rel', 'noopener');
        
        // Add to DOM
        document.body.appendChild(link);
        
        // Try multiple click approaches
        try {
          // Method 1: Direct click
          link.click();
          
          // Method 2: Synthetic click event
          setTimeout(() => {
            const clickEvent = new MouseEvent('click', {
              view: window,
              bubbles: true,
              cancelable: true
            });
            link.dispatchEvent(clickEvent);
          }, 50);
          
          // Method 3: Programmatic click as last resort
          setTimeout(() => {
            if (link.click) {
              link.click();
            }
          }, 100);
          
          // Method 4: Try iframe approach for iOS (more aggressive)
          setTimeout(() => {
            try {
              const iframe = document.createElement('iframe');
              iframe.style.display = 'none';
              iframe.src = dataUrl;
              document.body.appendChild(iframe);
              
              setTimeout(() => {
                if (document.body.contains(iframe)) {
                  document.body.removeChild(iframe);
                }
              }, 1000);
            } catch (iframeError) {
              console.log('Iframe method failed:', iframeError);
            }
          }, 200);
          
        } catch (clickError) {
          console.log('Click methods failed:', clickError);
        }
        
        // Clean up
        setTimeout(() => {
          if (document.body.contains(link)) {
            document.body.removeChild(link);
          }
        }, 2000);

        setDownloadStatus('PDF download initiated. Check your Downloads or Files app.');
        
        // Show instructions for manual saving if needed
        setTimeout(() => {
          setDownloadStatus('If PDF opened in browser, long press the PDF and select "Save to Files" or "Add to Files".');
        }, 2000);
      };
      
      reader.onerror = (error) => {
        console.error('Error reading PDF blob:', error);
        setDownloadStatus('Failed to prepare PDF for download. Please try again.');
      };
      
      reader.readAsDataURL(pdfBlob);

    } catch (error) {
      console.error('iOS PDF web fallback failed:', error);
      setDownloadStatus('PDF download failed. Please try the Web Share option above.');
    }
  };

  // Download blob with mobile support (similar to VisitingCard)
  const downloadBlob = (blob, filename, isShare = false) => {
    try {
      console.log('Starting download for BPF:', filename, 'Blob size:', blob.size, 'isShare:', isShare);

      // Enhanced mobile download handling
      const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      const isIOSDevice = isIOS();
      const isSafariBrowser = isSafari();
      
      console.log('Device type - Mobile:', isMobile, 'iOS:', isIOSDevice, 'Safari:', isSafariBrowser);

      // Handle iOS devices specifically
      if (isIOSDevice) {
        console.log('iOS device detected, using iOS-specific download handler');
        
        // Use specific PDF handler for PDF files on iOS
        if (filename.toLowerCase().endsWith('.pdf')) {
          console.log('iOS PDF download detected, using specialized PDF handler');
          handleIOSPDFDownload(blob, filename);
        } else {
          // For non-PDF files on iOS, use regular iOS download handler
          handleIOSDownload(blob, filename);
        }
        return;
      }

      // Try Cordova file handling first if available (for actual downloads)
      if (!isShare && window.cordova && window.cordova.file) {
        console.log('Attempting Cordova file save...');
        setDownloadStatus('Saving PDF to device...');
        
        saveFileToDevice(blob, filename).then((filePath) => {
          console.log('PDF saved successfully to:', filePath);
          setDownloadStatus(`PDF saved to device: ${filename}`);
          setTimeout(() => setDownloadStatus(''), 3000);
        }).catch((error) => {
          console.error('Cordova save failed, trying Web Share API...', error);
          // Fall through to Web Share API
          tryWebShareAPI();
        });
        return;
      }

      // For mobile downloads and shares, use Web Share API (allows users to choose "Save to Files")
      // This is the most reliable way to save files on mobile devices
      const tryWebShareAPI = () => {
        if (isMobile && navigator.share && navigator.canShare) {
          console.log('Attempting Web Share API for mobile...');
          const fileType = filename.endsWith('.pdf') ? 'application/pdf' : 'image/png';
          const file = new File([blob], filename, { type: fileType });
          
          if (navigator.canShare({ files: [file] })) {
            const shareTitle = filename.endsWith('.pdf') ? 'BPF Invitation PDF' : 'BPF Invitation';
            const shareText = isShare 
              ? '' 
              : `Download your ${filename.endsWith('.pdf') ? 'BPF invitation PDF' : 'BPF invitation image'}. Choose "Save to Files" to save to your device.`;
            
            navigator.share({
              files: [file],
              title: shareTitle,
              text: shareText
            }).then(() => {
              if (isShare) {
                setDownloadStatus('File shared successfully!');
              } else {
                setDownloadStatus('PDF shared! Choose "Save to Files" to download to your device.');
              }
              setTimeout(() => setDownloadStatus(''), 5000);
            }).catch((shareError) => {
              if (shareError.name !== 'AbortError') {
                console.log('Web Share failed, falling back to download:', shareError);
                setDownloadStatus('Sharing failed, trying alternative download...');
                fallbackDownload(blob, filename);
              } else {
                setDownloadStatus('');
              }
            });
            return true;
          }
        }
        return false;
      };

      if (tryWebShareAPI()) {
        return;
      }

      // For mobile devices without Web Share API, try to open in new tab
      if (isMobile && (!navigator.share || !navigator.canShare)) {
        console.log('Mobile device without Web Share API, opening PDF in new tab...');
        setDownloadStatus('Opening PDF for download...');
        
        try {
          const url = URL.createObjectURL(blob);
          const newWindow = window.open(url, '_blank');
          
          if (newWindow) {
            setDownloadStatus('PDF opened. Long press and select "Download" or "Save to Files".');
            // Clean up URL after a delay
            setTimeout(() => {
              URL.revokeObjectURL(url);
            }, 5000);
          } else {
            // If popup blocked, fall back to regular download
            console.log('Popup blocked, using fallback download...');
            fallbackDownload(blob, filename);
          }
          return;
        } catch (mobileError) {
          console.error('Mobile tab opening failed, falling back to download:', mobileError);
          fallbackDownload(blob, filename);
          return;
        }
      }

      // Regular download for desktop or when other methods are not available
      console.log('Using fallback download method...');
      setDownloadStatus('Downloading file...');
      fallbackDownload(blob, filename);
      return;

      // For share operations, use Web Share API
      if (isMobile && navigator.share && navigator.canShare) {
        console.log('Attempting Web Share API for sharing...');
        const fileType = filename.endsWith('.pdf') ? 'application/pdf' : 'image/png';
        const file = new File([blob], filename, { type: fileType });
        
        if (navigator.canShare({ files: [file] })) {
          const shareTitle = filename.endsWith('.pdf') ? 'BPF Invitation PDF' : 'BPF Invitation';
          
          navigator.share({
            files: [file],
            title: shareTitle
          }).then(() => {
            setDownloadStatus('File shared successfully!');
            setTimeout(() => setDownloadStatus(''), 3000);
          }).catch((shareError) => {
            if (shareError.name !== 'AbortError') {
              console.log('Web Share failed, falling back to download:', shareError);
              setDownloadStatus('Sharing failed, downloading instead...');
              fallbackDownload(blob, filename);
            } else {
              setDownloadStatus('');
            }
          });
          return;
        }
      }

      // Fallback for share if Web Share not available
      fallbackDownload(blob, filename);

    } catch (error) {
      console.error('Error:', error);
      setDownloadStatus('Download failed. Please try again.');
      // Ultimate fallback
      fallbackDownload(blob, filename);
    }
  };

  // Helper function to save file to a specific directory
  const saveFileToDirectory = (dirEntry, blob, filename, resolve, reject) => {
    dirEntry.getFile(filename, { create: true, exclusive: false }, (fileEntry) => {
      fileEntry.createWriter((fileWriter) => {
        fileWriter.onwriteend = () => {
          const filePath = fileEntry.nativeURL || fileEntry.fullPath;
          console.log('File saved successfully to:', filePath);
          resolve(filePath);
        };
        fileWriter.onerror = (error) => {
          console.error('Error writing file:', error);
          reject(error);
        };
        fileWriter.write(blob);
      }, (error) => {
        console.error('Error creating file writer:', error);
        reject(error);
      });
    }, (error) => {
      console.error('Error creating file:', error);
      reject(error);
    });
  };

  // Save file to device using Cordova - same as VisitingCard
  const saveFileToDevice = async (blob, filename) => {
    return new Promise((resolve, reject) => {
      try {
        // Check if we're in a Cordova environment
        if (window.cordova && window.cordova.file) {
          console.log('Using Cordova file API for device save');

          // Get the appropriate directory (prefer user-accessible locations)
          let directory;
          try {
            // Try to use user-accessible directories first
            if (window.cordova.file.externalRootDirectory) {
              // Try Downloads folder first
              directory = window.cordova.file.externalRootDirectory + 'Download/';
            } else if (window.cordova.file.documentsDirectory) {
              // Documents folder is usually accessible
              directory = window.cordova.file.documentsDirectory;
            } else if (window.cordova.file.externalDataDirectory) {
              // External data directory
              directory = window.cordova.file.externalDataDirectory;
            } else if (window.cordova.file.cacheDirectory) {
              // Cache directory as fallback
              directory = window.cordova.file.cacheDirectory;
            } else {
              // Last resort
              directory = window.cordova.file.dataDirectory;
            }
          } catch (dirError) {
            console.log('Error getting directory, using fallback:', dirError);
            directory = window.cordova.file.dataDirectory;
          }

          console.log('Using directory:', directory);

          // Use the modern Cordova file API
          if (window.resolveLocalFileSystemURL) {
            window.resolveLocalFileSystemURL(directory, (dirEntry) => {
              dirEntry.getFile(filename, { create: true, exclusive: false }, (fileEntry) => {
                fileEntry.createWriter((fileWriter) => {
                  fileWriter.onwriteend = () => {
                    const filePath = fileEntry.nativeURL || fileEntry.fullPath;
                    console.log('File saved successfully to:', filePath);
                    
                    // Provide more helpful success message
                    let successMessage = `File saved: ${filename}`;
                    if (directory.includes('Download')) {
                      successMessage += '\nCheck your Downloads folder';
                    } else if (directory.includes('Documents')) {
                      successMessage += '\nCheck your Documents folder';
                    } else {
                      successMessage += '\nFile saved to app storage';
                    }
                    
                    setDownloadStatus(successMessage);
                    
                    // Show toast notification if available
                    if (window.cordova && window.cordova.plugins && window.cordova.plugins.toast) {
                      window.cordova.plugins.toast.show(`Downloaded: ${filename}`, 'long', 'bottom');
                    }
                    
                    resolve(filePath);
                  };

                  fileWriter.onerror = (error) => {
                    console.error('Error writing file:', error);
                    reject(error);
                  };

                  // Write the blob directly
                  fileWriter.write(blob);
                }, (error) => {
                  console.error('Error creating file writer:', error);
                  reject(error);
                });
              }, (error) => {
                console.error('Error creating file:', error);
                // Try to create the directory first if it doesn't exist
                if (error.code === 1) { // NOT_FOUND_ERR = 1
                  console.log('Directory not found, trying to create it...');
                  
                  // Try multiple directory creation strategies
                  const tryCreateDirectory = (baseDir, dirName, callback) => {
                    window.resolveLocalFileSystemURL(baseDir, (rootEntry) => {
                      rootEntry.getDirectory(dirName, { create: true }, (dirEntry) => {
                        callback(null, dirEntry);
                      }, (dirError) => {
                        console.log(`Failed to create ${dirName} in ${baseDir}, trying alternative...`);
                        callback(dirError, null);
                      });
                    }, (baseError) => {
                      console.log(`Failed to access ${baseDir}, trying alternative...`);
                      callback(baseError, null);
                    });
                  };
                  
                  // Try Downloads directory first
                  tryCreateDirectory(window.cordova.file.externalRootDirectory, 'Download', (err, dirEntry) => {
                    if (err) {
                      // Try Documents directory
                      tryCreateDirectory(window.cordova.file.documentsDirectory, '', (err2, dirEntry2) => {
                        if (err2) {
                          // Try external data directory
                          tryCreateDirectory(window.cordova.file.externalDataDirectory, '', (err3, dirEntry3) => {
                            if (err3) {
                              console.error('All directory creation attempts failed');
                              reject(err3);
                            } else {
                              saveFileToDirectory(dirEntry3, blob, filename, resolve, reject);
                            }
                          });
                        } else {
                          saveFileToDirectory(dirEntry2, blob, filename, resolve, reject);
                        }
                      });
                    } else {
                      saveFileToDirectory(dirEntry, blob, filename, resolve, reject);
                    }
                  });
                } else {
                  reject(error);
                }
              });
            }, (err) => {
              console.error('Error accessing directory:', err);
              reject(err);
            });
          } else {
            // Fallback to legacy method if modern API not available
            console.log('Using legacy Cordova file API');
            
            // Convert blob to base64 for legacy API
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const base64Data = reader.result.split(',')[1];
                
                window.cordova.file.writeFile(directory, filename, base64Data, true,
                  (success) => {
                    const filePath = directory + filename;
                    console.log('File saved successfully to:', filePath);
                    setDownloadStatus(`File saved to device: ${filename}`);
                    resolve(filePath);
                  },
                  (error) => {
                    console.error('Error writing file with legacy API:', error);
                    reject(error);
                  }
                );
              } catch (conversionError) {
                console.error('Error converting blob to base64:', conversionError);
                reject(conversionError);
              }
            };
            
            reader.onerror = (error) => {
              console.error('Error reading blob:', error);
              reject(error);
            };
            
            reader.readAsDataURL(blob);
          }
        } else {
          // Not in Cordova environment - use web download
          console.log('Not in Cordova environment, using web download');
          try {
            // Create a download link
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            link.style.display = 'none';

            // Add to DOM, click, and remove
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Clean up the URL after a delay
            setTimeout(() => {
              URL.revokeObjectURL(url);
            }, 1000);

            // Return a mock file path for consistency
            const mockPath = `file:///downloads/${filename}`;
            setDownloadStatus(`File downloaded: ${filename}`);
            resolve(mockPath);
          } catch (fallbackError) {
            console.error('Web download fallback failed:', fallbackError);
            reject(fallbackError);
          }
        }
      } catch (error) {
        console.error('Error in saveFileToDevice:', error);
        reject(error);
      }
    });
  };

  // Handle iOS download for non-PDF files
  const handleIOSDownload = (blob, filename) => {
    try {
      console.log('Handling iOS download for:', filename);
      setDownloadStatus('Preparing download for iOS...');

      // Try Web Share API first (iOS 13+)
      if (navigator.share && navigator.canShare) {
        try {
          const file = new File([blob], filename, { 
            type: filename.endsWith('.png') ? 'image/png' : 'image/jpeg' 
          });
          
          if (navigator.canShare({ files: [file] })) {
            navigator.share({
              files: [file],
              title: 'BPF Invitation',
              text: 'Save to Files to download'
            }).then(() => {
              setDownloadStatus('File shared successfully! Choose "Save to Files" to download.');
            }).catch((error) => {
              console.log('Web Share failed, trying alternative method:', error);
              openInNewTab(blob, filename);
            });
            return;
          }
        } catch (shareError) {
          console.log('Web Share API error, trying fallback:', shareError);
        }
      }

      // Fallback: Open in new tab
      openInNewTab(blob, filename);

    } catch (error) {
      console.error('iOS download failed:', error);
      setDownloadStatus('Download failed. Please try again.');
    }
  };

  // Open blob in new tab (for iOS fallback)
  const openInNewTab = (blob, filename) => {
    try {
      const url = URL.createObjectURL(blob);
      const newWindow = window.open(url, '_blank');
      
      if (newWindow) {
        setDownloadStatus('File opened in new tab. Long press and save on iOS.');
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      } else {
        setDownloadStatus('Please allow popups to download the file.');
      }
    } catch (error) {
      console.error('Error opening in new tab:', error);
      setDownloadStatus('Download failed. Please try again.');
    }
  };

  // Fallback download method - Enhanced for mobile
  const fallbackDownload = (blob, filename) => {
    try {
      const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      
      // For mobile, try multiple approaches to ensure download
      if (isMobile) {
        // Approach 1: Try blob URL download with enhanced attributes
        try {
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          link.style.display = 'none';
          link.setAttribute('download', filename);
          link.setAttribute('type', 'application/pdf');
          link.setAttribute('rel', 'noopener');
          
          document.body.appendChild(link);
          
          // Try immediate click
          link.click();
          
          // Also try programmatic click after a delay (for some mobile browsers)
          setTimeout(() => {
            if (link.click) {
              link.click();
            }
          }, 100);
          
          // Clean up
          setTimeout(() => {
            if (document.body.contains(link)) {
              document.body.removeChild(link);
            }
            URL.revokeObjectURL(url);
          }, 2000);
          
          setDownloadStatus('PDF download initiated. Check your Downloads folder.');
          setTimeout(() => {
            setDownloadStatus('If not found, check browser downloads or try opening the PDF link.');
          }, 3000);
          return;
        } catch (error) {
          console.log('Blob URL download failed, trying data URL...', error);
        }
        
        // Approach 2: Try data URL (more compatible with mobile browsers)
        try {
          const reader = new FileReader();
          reader.onload = () => {
            const dataUrl = reader.result;
            const link = document.createElement('a');
            link.href = dataUrl;
            link.download = filename;
            link.style.display = 'none';
            link.setAttribute('download', filename);
            link.setAttribute('type', 'application/pdf');
            
            document.body.appendChild(link);
            link.click();
            
            setTimeout(() => {
              if (document.body.contains(link)) {
                document.body.removeChild(link);
              }
            }, 2000);
            
            setDownloadStatus('PDF download initiated. Check your Downloads folder.');
            setTimeout(() => setDownloadStatus(''), 5000);
          };
          reader.onerror = () => {
            setDownloadStatus('Download failed. Please try again.');
          };
          reader.readAsDataURL(blob);
          return;
        } catch (error) {
          console.log('Data URL download failed:', error);
        }
        
        // Approach 3: Open in new tab as last resort (user can manually save)
        try {
          const url = URL.createObjectURL(blob);
          const newWindow = window.open(url, '_blank');
          if (newWindow) {
            setDownloadStatus('PDF opened. Long press and select "Download" or "Save to Files".');
            setTimeout(() => URL.revokeObjectURL(url), 5000);
          } else {
            setDownloadStatus('Please allow popups to download the PDF.');
          }
          return;
        } catch (error) {
          console.log('Open in new tab failed:', error);
          setDownloadStatus('Download failed. Please try again.');
        }
      } else {
        // Desktop download - standard approach
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(url), 1000);
        setDownloadStatus('PDF downloaded successfully!');
        setTimeout(() => setDownloadStatus(''), 3000);
      }
    } catch (error) {
      console.error('Error in fallbackDownload:', error);
      setDownloadStatus('Download failed. Please try again.');
    }
  };

  // Fetch PDF with multiple fallback paths (for iOS compatibility)
  const fetchPDFBlob = async () => {
    // Add cache-busting timestamp to ensure latest PDF is fetched
    const cacheBuster = `?t=${Date.now()}`;
    const paths = [
      `/doc/BPF.pdf${cacheBuster}`,
      `./doc/BPF.pdf${cacheBuster}`,
      `${window.location.origin}/doc/BPF.pdf${cacheBuster}`,
      `${window.location.origin}/public/doc/BPF.pdf${cacheBuster}`
    ];

    for (const path of paths) {
      try {
        console.log(`Attempting to fetch PDF from: ${path}`);
        const response = await fetch(path, {
          method: 'GET',
          headers: {
            'Accept': 'application/pdf',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
          },
          cache: 'no-store' // Force bypass cache
        });
        
        if (response.ok) {
          const blob = await response.blob();
          if (blob && blob.size > 0) {
            console.log(`Successfully fetched PDF from: ${path}, size: ${blob.size}`);
            return blob;
          }
        }
      } catch (error) {
        console.log(`Failed to fetch from ${path}:`, error);
        continue;
      }
    }
    
    throw new Error('Failed to fetch PDF from all available paths');
  };

  // Handle PDF download with mobile support - similar to VisitingCard
  const handleDownload = async () => {
    setDownloadStatus('Preparing PDF download...');

    try {
      // Fetch the PDF file with fallback paths
      const blob = await fetchPDFBlob();
      const filename = `BPF-Invitation-${user?.peacekeeper_id || 'document'}.pdf`;
      
      // Use downloadBlob function (similar to VisitingCard) which handles mobile and desktop downloads
      downloadBlob(blob, filename);
      
    } catch (err) {
      console.error('Download error:', err);
      setDownloadStatus('Failed to download PDF. Please try again.');
      setTimeout(() => setDownloadStatus(''), 5000);
    }
  };

  // Handle share - open native sharing options with PDF (works same as Certificate for web)
  const handleShareNoDownload = async () => {
    try {
      setIsSharing(true);
      setDownloadStatus('Preparing PDF for sharing...');
      
      // Fetch the PDF file with fallback paths
      const blob = await fetchPDFBlob();
      const filename = `BPF-Invitation-${user?.peacekeeper_id || 'document'}.pdf`;

      // Check if mobile device
      const isMobileDevice = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      const isIOSDevice = isIOS();

      // For mobile (iOS and Android), use Web Share API directly
      if (isMobileDevice) {
        try {
          const file = new File([blob], filename, { type: 'application/pdf' });
          
          if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
            navigator.share({
              files: [file],
              title: 'BPF Invitation',
              text: getBPFShareMessage(user)
            }).then(() => {
              setDownloadStatus('BPF invitation PDF shared successfully!');
              setIsSharing(false);
              setTimeout(() => setDownloadStatus(''), 3000);
            }).catch((shareError) => {
              if (shareError.name !== 'AbortError') {
                console.error('Web Share failed:', shareError);
                setDownloadStatus('Sharing failed. Please try again.');
              } else {
                setDownloadStatus('');
              }
              setIsSharing(false);
            });
            return;
          }
        } catch (error) {
          console.error('Mobile share error:', error);
          // Fall through to web handling
        }
      }

      // For web (desktop), use Web Share API if available, otherwise fallback
      if (navigator.share && navigator.canShare) {
        try {
          const file = new File([blob], filename, { type: 'application/pdf' });
          
          // Check if Web Share API supports files (some browsers may not)
          if (navigator.canShare({ files: [file] })) {
            navigator.share({
              files: [file],
              title: 'BPF Invitation',
              text: getBPFShareMessage(user)
            }).then(() => {
              setDownloadStatus('BPF invitation PDF shared successfully!');
              setIsSharing(false);
              setTimeout(() => setDownloadStatus(''), 3000);
            }).catch((shareError) => {
              if (shareError.name !== 'AbortError') {
                console.error('Web Share failed:', shareError);
                // Fallback to download
                downloadBlob(blob, filename, false);
                setIsSharing(false);
              } else {
                setDownloadStatus('');
                setIsSharing(false);
              }
            });
            return;
          }
        } catch (error) {
          console.error('Web Share API error:', error);
          // Fall through to fallback
        }
      }

      // Fallback: Use downloadBlob for sharing (will handle Cordova if available)
      downloadBlob(blob, filename, true);
      setIsSharing(false);
      
    } catch (error) {
      console.error('Error sharing BPF invitation:', error);
      setDownloadStatus('Failed to share BPF invitation. Please try again.');
      setIsSharing(false);
    }
  };


  // Share PDF to WhatsApp (Cordova) - PDF only, no message
  const sharePDFToWhatsApp = async (blob, filename) => {
    try {
      if (!window.cordova || !window.cordova.file || !window.plugins || !window.plugins.socialsharing) {
        throw new Error('Cordova plugins not available');
      }

      // Create temporary file
      const directory = window.cordova.file.cacheDirectory || window.cordova.file.dataDirectory;
      if (!directory) {
        throw new Error('No valid Cordova file directory available');
      }

      const filePath = await new Promise((resolve, reject) => {
        window.resolveLocalFileSystemURL(directory, function (dirEntry) {
          dirEntry.getFile(filename, { create: true }, function (fileEntry) {
            fileEntry.createWriter(function (fileWriter) {
              fileWriter.onwriteend = () => resolve(fileEntry.nativeURL);
              fileWriter.onerror = (e) => reject(e);
              fileWriter.write(blob);
            });
          }, reject);
        }, reject);
      });

      // Share PDF file only (no message)
      window.plugins.socialsharing.shareWithOptions({
        subject: 'BPF Invitation',
        files: [filePath],
        chooserTitle: 'Share BPF Invitation via'
      }, (result) => {
        console.log("✅ PDF shared successfully!");
        setDownloadStatus('BPF invitation PDF shared successfully!');
        setIsSharing(false);
      }, (error) => {
        console.error("❌ Sharing failed:", error);
        setDownloadStatus('Sharing failed. Please try again.');
        setIsSharing(false);
      });
    } catch (error) {
      console.error('Error sharing PDF:', error);
      setDownloadStatus('Failed to prepare PDF for sharing.');
      setIsSharing(false);
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      {/* Page Indicator */}
      {invitationImages.length > 0 && (
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          gap: 1,
          alignItems: 'center'
        }}>
          {/* Previous Button */}
          <Button
            variant="outlined"
            startIcon={<NavigateBeforeIcon />}
            onClick={prevPage}
            disabled={currentPage === 0}
            size="small"
            sx={{
              minWidth: 'auto',
            }}
          />
          
          {/* Page Dots */}
          {Array.from({ length: totalPages }, (_, i) => i).map((page) => (
            <Box
              key={page}
              sx={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                bgcolor: currentPage === page ? '#3A8139' : '#e0e0e0',
                cursor: 'pointer'
              }}
              onClick={() => setCurrentPage(page)}
            />
          ))}
          
          {/* Next Button */}
          <Button
            variant="outlined"
            endIcon={<NavigateNextIcon />}
            onClick={nextPage}
            disabled={currentPage >= totalPages - 1}
            size="small"
            sx={{
              minWidth: 'auto',
            }}
          />
        </Box>
      )}

      {/* Status Message */}
      {downloadStatus && (
        <Box sx={{ 
          textAlign: 'center', 
          bgcolor: downloadStatus.includes('successfully') || downloadStatus.includes('Shared') ? 'success.light' : 'info.light',
          borderRadius: 1
        }}>
          <Typography variant="body2" color="text.secondary">
            {downloadStatus}
          </Typography>
        </Box>
      )}

      {/* Invitation Images Content */}
      <Box 
        className="invitation-content"
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center',
          width: '100%',
          minHeight: '560px'
        }}
      >
        {renderPage()}
      </Box>

      {/* Page Info */}
      {invitationImages.length > 0 && (
        <Box sx={{ 
          textAlign: 'center', 
          mt: 1,
          p: 1,
          bgcolor: 'grey.50',
          borderRadius: 1
        }}>
          <Typography variant="body2" color="text.secondary">
            Page {currentPage + 1} of {totalPages}
          </Typography>
        </Box>
      )}

      {/* Action Buttons */}
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        mt: 3,
        flexWrap: 'wrap',
        gap: 2
      }}>
          <Button
            variant="outlined"
            startIcon={<ShareIcon />}
            onClick={() => setShowMessagePreview(true)}
            disabled={invitationImages.length === 0}
            sx={{
              borderColor: '#214F7D',
              color: '#214F7D',
              textTransform: 'none',
              '&:hover': { 
                borderColor: '#1a3f63',
                backgroundColor: 'rgba(33, 79, 125, 0.04)'
              }
            }}
          >
            Preview and Share
          </Button>
        
        <Button
          variant="contained"
          startIcon={<PictureAsPdfIcon />}
          onClick={handleDownload}
          disabled={invitationImages.length === 0}
          sx={{
            bgcolor: '#3A8139',
            color: 'white',
            textTransform: 'none',
            '&:hover': { bgcolor: '#2d652c' }
          }}
        >
          Download PDF
        </Button>
      </Box>

      {/* Share Preview Modal (same as Certificate) */}
      <Dialog
        open={showMessagePreview}
        onClose={() => setShowMessagePreview(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          BPF Invitation Preview
          <IconButton
            aria-label="close"
            onClick={() => setShowMessagePreview(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            maxHeight: '70vh',
            overflowY: 'auto'
          }}
        >
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Message Preview:
            </Typography>
            <Paper
              elevation={0}
              sx={{
                p: 2,
                bgcolor: '#f5f5f5',
                borderRadius: 1,
                whiteSpace: 'pre-wrap',
                fontFamily: 'inherit',
                fontSize: '0.9rem',
                wordBreak: 'break-word',
                lineHeight: 1.6
              }}
            >
              {getBPFShareMessage(user)}
            </Paper>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, justifyContent: 'space-between' }}>
          <Button
            onClick={() => setShowMessagePreview(false)}
            color="inherit"
          >
            Cancel
          </Button>
          <Button
            onClick={async () => {
              setShowMessagePreview(false);
              await handleShareNoDownload();
            }}
            variant="contained"
            startIcon={<ShareIcon />}
            disabled={isSharing}
            sx={{
              borderColor: '#214F7D',
              bgcolor: '#214F7D',
              '&:hover': { bgcolor: '#1a3f63' }
            }}
          >
            Share Via
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default BPF;
